import { useCallback, useEffect, useState } from 'react'
import { contentAuthorize } from 'api/auth'
import useShakaPlayer from 'hooks/useShakaPlayer'
import { Content } from 'types/app'
import { t } from 'helpers'

interface Props {
	content: Content
}

const Video = ({ content }: Props): JSX.Element => {
	const [contentUrl, setContentUrl] = useState('')

	useShakaPlayer(contentUrl || '', 'rolescene_' + content?.ContentId)

	const fetchVideoUrl = useCallback(async (): Promise<void> => {
		try {
			const response = await contentAuthorize(content.ContentId)
			if (response?.Properties) {
				setContentUrl(
					response.Properties.find((value) => value.Name === 'Content:Url')
						?.Value || '',
				)
			}
		} catch (error) {
			console.log('error:', error)
		}
	}, [content.ContentId])

	useEffect(() => {
		if (!contentUrl) {
			fetchVideoUrl()
		}
	}, [contentUrl, fetchVideoUrl])

	return (
		<div
			style={{
				borderRadius: '15px',
				overflow: 'hidden',
				display: 'flex',
			}}>
			{content && !contentUrl ? (
				<div
					style={{
						position: 'relative',
						height: 'calc(392px / var(--videoAspect))',
						width: '100%',
					}}>
					<img
						src={content?.ContentSquareImageUrl || '/video-placeholder.png'}
						style={{ width: '100%', height: '100%', objectFit: 'cover' }}
					/>
					{!content?.ContentSquareImageUrl && (
						<span
							style={{
								position: 'absolute',
								top: '50%',
								left: '50%',
								transform: 'translate(-50%, -50%)',
							}}>
							{t('APP_VIDEO_UPLOAD')}
						</span>
					)}
				</div>
			) : (
				<video
					id={'rolescene_' + content?.ContentId}
					controls
					style={{ width: '100%', height: 'calc(392px / var(--videoAspect))' }}
				/>
			)}
		</div>
	)
}

export default Video
